import { AddShoppingCartOutlined } from "@mui/icons-material";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart,strLoggedIn,cartItems,productsArray }) => {
  return (
    <Card className="card" > 
      <CardMedia
      component="img"
      height="140"
      image={product.image}
      alt={product.name}>
      </CardMedia>
      <CardContent>
        <Typography variant="h5" >
            {product.name}
        </Typography>
        <Typography variant="h6" >
        {"$"+product.cost}
        </Typography>
        <Rating name="read-only" value={product.rating} readOnly />
        </CardContent>
      <CardActions>
        <Button variant="contained" startIcon={<AddShoppingCartIcon/>} onClick={()=>handleAddToCart(strLoggedIn,cartItems,productsArray,product._id,1,true)}>Add to Cart</Button>
      </CardActions>
    </Card>
  );
};

export default ProductCard;
